import { Text } from "@aidron/aidron-ds";

import { 
  CustomHeading,
  CustomText
} from "../../StyledComponents/styleComponents.index";

import PropTypes from 'prop-types';

export function TextAndLabelView({ label, labelSize, text, textColor, fontWeight, heading, contentSize }) {

  return (
    <div className="d-flex flex-column align-items-center">
      <Text size={labelSize}>{label}</Text>
      {text && (
        <CustomText fontSize={['0.3rem', '0.6rem', '1rem']} weight="bold" color={textColor}>
          {text}
        </CustomText>
      )}
      {heading && <CustomHeading size={contentSize ?? "md"} fontWeight={fontWeight ?? 500}>{heading}</CustomHeading>}
    </div>
  );
};

TextAndLabelView.propTypes = {
  label: PropTypes.string,
  labelSize: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([undefined])
  ]),
  heading: PropTypes.string,
  contentSize: PropTypes.string
}